import { useAlertHook } from 'app/hooks/useAlertHook';
import styles from './Alerts.module.scss';
import { Message } from 'ais-facade-api/api';
import { useEffect, useState } from 'react';
import { Icon } from '../Icon/Icon';
import clsx from 'clsx';


interface AlertI {
  closable?: boolean;
  timeout?: number;
  message?: Message;
  onClose?: () => void;
  fadeIn?: boolean;
  fadeOut?: boolean;
  className?: string;
}

const MessageView = ({ message, closable, onClose, fadeIn, fadeOut, className }: AlertI) => {
  return (
    <div data-type={message?.type} className={clsx(styles.alert, className)} data-fadein={fadeIn} data-fadeout={fadeOut}>
      <Icon name={message && message.type ? message.type : 'warning'} />
      <span className={styles.description}>{message?.description}</span>
      {closable && (
        <div onClick={onClose} className={styles.close}>
          <Icon name="close-16" size="16" />
        </div>
      )}
    </div>
  );
};

export const Alert = ({ closable = true, timeout = 4000, className }: AlertI) => {
  const { alert, removeAlert } = useAlertHook();
  const [fadeIn, setFadeIn] = useState<boolean>(false);
  const [fadeOut, setFadeOut] = useState<boolean>(false);
  const handleClose = () => {
    setTimeout(() => {
      removeAlert();
    }, 2000);
  };

  useEffect(() => {
    if (alert && alert.data) {
      setFadeIn(true);
    }
  }, [alert]);

  useEffect(() => {
    if (fadeIn) {
      setTimeout(() => {
        setFadeIn(false);
        setFadeOut(true);
      }, 3000);
    }
  }, [fadeIn]);

  useEffect(() => {
    if (!fadeIn && fadeOut) {
      setTimeout(() => {
        removeAlert();
        setFadeOut(false);
      }, 50);
    }
  }, [fadeOut]);

  return (
    <>
      {alert &&
        alert.data?.messages?.map((message, index) => {
          return (
            <MessageView
              className={className}
              key={index}
              message={message}
              closable={closable}
              onClose={handleClose}
              timeout={timeout}
              fadeIn={fadeIn}
              fadeOut={fadeOut}
            />
          );
        })}
    </>
  );
};
